module.exports = __webpack_public_path__ + "static/media/NOD2.23f0d3bb.png";